"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RsIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RsIconSpan = _styled["default"].span({
  display: "inline-block",
  userSelect: "none",
  userDrag: "none",
  WebkitTouchCallout: "none",
  WebkitUserSelect: "none",
  KhtmlUserSelect: "none",
  MozUserSelect: "none",
  MsUserSelect: "none",
  WebkitUserDrag: "none",
  "& span": {
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    display: "inline-block"
  },
  "& .innerText": {
    pointerEvents: "none"
  }
});

var RsIcon = /*#__PURE__*/function (_PureComponent) {
  _inherits(RsIcon, _PureComponent);

  var _super = _createSuper(RsIcon);

  function RsIcon() {
    var _this;

    _classCallCheck(this, RsIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "shouldDisplayNumber", function () {
      return _this.state.hover && _this.props.navnumber || _this.props.ico === "PathstepCurrent";
    });

    _defineProperty(_assertThisInitialized(_this), "getDynamicStyles", function () {
      var cssObj = {};

      if (_this.props.widthheight) {
        cssObj["width"] = "".concat(_this.props.widthheight, "px");
        cssObj["height"] = "".concat(_this.props.widthheight, "px");
      }

      var iconStyles = _this.props.iconStyle;
      var mergedStyles = iconStyles ? _objectSpread(_objectSpread({}, cssObj), iconStyles) : cssObj;

      if (_this.props.useStyles) {
        // Mapping has styles instead of class names.
        mergedStyles = _objectSpread(_objectSpread({}, mergedStyles), _this.props.mapping[_this.props.ico]);
      }

      return mergedStyles;
    });

    _defineProperty(_assertThisInitialized(_this), "state", {
      hover: false
    });

    _defineProperty(_assertThisInitialized(_this), "mouseOver", function () {
      _this.setState({
        hover: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mouseOut", function () {
      _this.setState({
        hover: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "numberOffset", function () {
      // If we shrink down the icon, we need to offset the text to keep it centered on the background icon.
      var offsets = {
        22: {
          fontSize: "13px",
          top: "-1px",
          position: "relative"
        },
        21: {
          fontSize: "13px",
          top: "-1px",
          position: "relative"
        },
        20: {
          fontSize: "12px",
          top: "-2px",
          position: "relative"
        },
        19: {
          fontSize: "12px",
          top: "-2px",
          position: "relative"
        },
        18: {
          fontSize: "11px",
          top: "-3px",
          position: "relative"
        },
        17: {
          fontSize: "10px",
          top: "-4px",
          position: "relative"
        },
        16: {
          fontSize: "10px",
          top: "-4px",
          position: "relative"
        },
        15: {
          fontSize: "10px",
          top: "-4px",
          position: "relative"
        },
        14: {
          fontSize: "9px",
          top: "-5px",
          position: "relative"
        },
        13: {
          fontSize: "9px",
          top: "-5px",
          position: "relative"
        }
      };
      return offsets[_this.props.widthheight] || null;
    });

    return _this;
  }

  _createClass(RsIcon, [{
    key: "getClassName",
    value: function getClassName() {
      // mapping passed in string for this.props.ico
      // to css class in RsIcon.css
      if (this.props.useStyles) {
        return "";
      }

      return this.props.mapping[this.props.ico];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(RsIconSpan, {
        className: "rs-icon",
        style: this.props.style,
        onClick: this.props.onClick,
        "data-qa": "RSIcon-".concat(this.props.ico, "-").concat(this.props.navnumber || 0)
      }, this.getClassName() || this.props.useStyles ? /*#__PURE__*/_react["default"].createElement("span", {
        style: this.getDynamicStyles(),
        onMouseOver: this.mouseOver,
        onMouseOut: this.mouseOut,
        className: this.getClassName()
      }, this.shouldDisplayNumber() ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "innerText",
        style: this.numberOffset()
      }, this.props.navnumber) : "\xA0") : null);
    }
  }]);

  return RsIcon;
}(_react.PureComponent);

exports.RsIcon = RsIcon;
RsIcon.propTypes = {
  style: _propTypes["default"].object,
  ico: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  widthheight: _propTypes["default"].number,
  useStyles: _propTypes["default"].bool,
  navnumber: _propTypes["default"].number
};
RsIcon.defaultProps = {
  useStyles: false
};
var _default = RsIcon;
exports["default"] = _default;